import {useEffect , useState} from "react";
import { IonApp, 
    IonHeader, 
    IonToolbar, 
    IonTitle, 
    IonContent, 
    IonFooter, 
    IonMenu,
    IonList,
    IonListHeader,
    IonMenuToggle,
    IonIcon,
    IonCol,
    IonLabel,
    IonPage ,
    IonButtons,
    IonButton,
    IonItem, 
    IonRow,
    IonGrid,} from '@ionic/react';
import { DatePicker } from "antd";
import 'react-circular-progressbar/dist/styles.css';
import { getDeliveryAnalyticsData, getOrderBreakdown, getPaymentBreakdownAnalytics } from "../pages/dashboard/apiService"
import '../styles/style.css'

import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Legend, 
  Tooltip,
  PieChart, Pie, Cell, ResponsiveContainer
} from "recharts";
import { getMemberProfile } from "../pages/newDelivery/services/apiService"
import moment from "moment";
import 'antd/dist/antd.min.css';


function CorePageComponent (props){

  const [memberData, setMemberData] = useState({})
  const getMemberData = async () => {
    let data = await getMemberProfile()
    setMemberData(data)
  }
  
  useEffect(()=>{
    
    setDeliveryChartData()
    setOrderBreakdownAnalyticsData()
    setPaymentBreakdownAnalyticsData()
    getMemberData()
    sessionStorage.clear()
  },[])
  const [deliveryAnalyticsData, setDeliveryAnalyticsData] = useState([])
  const [paymentAnalyticsData, setPaymentAnalyticsData] = useState([])
  const [orderBreakdownData, setOrderBreakdownData] = useState({})

  const setDeliveryChartData = async (startTime, endTime) => {
    

    let data 
    if (!startTime || !endTime) {
      data = await getDeliveryAnalyticsData(moment().subtract('days',30).unix(), moment().unix())
    }  else {
      data = await getDeliveryAnalyticsData(startTime, endTime)
    }
    
    setDeliveryAnalyticsData(data)
  } 

  const handleDateSelectForDeliveryAnalytics = async (val) => {
    setDeliveryChartData(val[0].unix(), val[1].unix())
  }

  const setOrderBreakdownAnalyticsData = async (startTime, endTime) => {
    let data 
    if (!startTime || !endTime) {
      data = await getOrderBreakdown(moment().subtract('days',30).unix(), moment().unix())
    }  else {
      data = await getOrderBreakdown(startTime, endTime)
    }
    
    setOrderBreakdownData(data)
  } 

  const setPaymentBreakdownAnalyticsData = async (startTime, endTime) => {
    let data 
    if (!startTime || !endTime) {
      data = await getPaymentBreakdownAnalytics(moment().subtract('days',30).unix(), moment().unix())
    }  else {
      data = await getPaymentBreakdownAnalytics(startTime, endTime)
    }
    
    setPaymentAnalyticsData(data)
  }

  const { RangePicker } = DatePicker;

  

  const dot = (dotColor) => {
    return {
      height: "25px" ,
      width: "25px",
      backgroundColor: dotColor,
      borderRadius: "50%",
    }
  }

  const renderLegend = () => {
    
    return (
      <>
      <div style={{ display: "flex" ,   justifyContent: "space-between"}}>
        <div>
          <div  style={dot("#E93465")}></div>
          <p style={{color:"black"}}><b>{orderBreakdownData.singleDropoff}</b><br/>1 Stop</p> 
        </div>
        <div>
          <div  style={dot("#FC7EA1")}></div> 
          <p style={{color:"black"}}><b>{orderBreakdownData.doubleDropOff}</b><br/>2 Stop</p> 
        </div>
        <div>
          <div  style={dot("#FDB7CA")}></div> 
          <p style={{color:"black"}}><b>{orderBreakdownData.tripleDropOff}</b><br/>3 Stop</p> 
        </div>
        <div>
          <div  style={dot("#FEECF1")}></div> 
          <p style={{color:"black"}}><b>{orderBreakdownData.moreThan4DropOff}</b><br/>4 Stop</p> 
        </div>
        
      </div>
      </>
    );
  }

  const renderLegendForPaymentMethods = () => {
    return (
      <>
      <div style={{ display: "flex" ,   justifyContent: "space-between"}}>
        {
          paymentAnalyticsData && paymentAnalyticsData.map((data, index)=>{
            return (
              <div>
                <div  style={dot(COLORS[index])}></div>
                <p style={{color:"black"}}><b>{Math.round(data.amount)}</b><br/>{data.brand}</p> 
              </div>
            )
          })
        } 
        
        </div>
      </>
    )
  }

  const COLORS = ["#E93465" , "#FC7EA1" , "#FDB7CA", "#FEECF1"];


    return (
        <> 
       <IonApp>
        <IonPage className="ion-page dashboard-bg core-wrapper" id="main-content">
        <IonToolbar className='header-toolbar'>
          <IonButtons slot="start" className='home-btn'>
          
                <IonMenuToggle>
                  <IonButton>
                  <img src='../img/menu-icon.png' />
                  </IonButton>
                </IonMenuToggle>
                
              </IonButtons>
              <img className='header-logo' src='../img/logo.png' />
          </IonToolbar>
          <IonContent className="ion-padding page-title">
            <div className="wrapper dashboard-page">
              <h1>Dashboard</h1>
              
            <div className="mobile-scroll">
            <ion-grid>
              <ion-row>
                <ion-col>
                  <ion-card>
                    <ion-card-header>
                      <ion-card-subtitle>Total Spent:<span></span></ion-card-subtitle>
                      <ion-card-title><span>$</span>{props.totalAmt}</ion-card-title>
                    </ion-card-header>
                  </ion-card>
                </ion-col>
                <ion-col>
                  <ion-card className="second">
                    <ion-card-header>
                      <ion-card-subtitle>Total Trips:<span></span></ion-card-subtitle>
                      <ion-card-title>{props.countTrips}</ion-card-title>
                    </ion-card-header>
                  </ion-card>
                </ion-col>
                <ion-col>
                  <ion-card>
                    <ion-card-header>
                      <ion-card-subtitle>Total Deliveries:<span></span></ion-card-subtitle>
                      <ion-card-title>{props.countDeliveries}</ion-card-title>
                    </ion-card-header>
                  </ion-card>
                </ion-col>
              </ion-row>
            </ion-grid>
            </div>
            
            <div className="dashboard-card-wrapper">
              <IonGrid>
                <IonRow>
                  <IonCol size="6">
                  <h4><b>Deliveries</b></h4>
                  </IonCol>
                  <IonCol size="6">
                    <RangePicker
                      onChange={(val) => handleDateSelectForDeliveryAnalytics(val)}
                    />
                  </IonCol>
                  <IonCol size="12">
                  { deliveryAnalyticsData &&
              
                        <LineChart 
                          width={860}
                          height={400}
                          data={deliveryAnalyticsData}
                          
                        >
                        
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="date" />
                        <YAxis />
                        <Tooltip />
                        <Legend />
                        <Line type="monotone" dataKey="totalDeliveries" name="Total Deliveries" stroke="#E93864" strokeWidth={5} />
                        </LineChart>


                        }
                        {
                      !deliveryAnalyticsData && 
                        <p>No bookings for the past 7 days</p>
                      }
                  </IonCol>
                </IonRow>
                
             

               </IonGrid>
            </div>
            <IonGrid className="dash-col">
              <IonRow>
              <IonCol size="6">
                  <div className="dashboard-card-wrapper pie-chart"> {/*//text={`${67}% Trips with >1 dropoff`} */}
                  { orderBreakdownData.total !== 0 &&
                  
                    <IonGrid>
                        <IonRow tyle={{
                          width:'100%',
                          margin:'20px',
                          padding: "50px"
                        }}>
                          <IonCol size="12">
                            <h4><b>Order Type Breakdown</b></h4>
                          </IonCol>
                          <IonCol>

                          {orderBreakdownData &&
                          
                            <PieChart width={800} height={400} > 
                            <Pie
                              data={[{
                                name: '1 Stop' ,
                                value: orderBreakdownData.singleDropoff
                              },
                              {
                                name: '2 Stops' ,
                                value: orderBreakdownData.doubleDropOff
                              },
                              {
                                name: '3 Stops' ,
                                value: orderBreakdownData.tripleDropOff
                              },
                              {
                                name: '>4 Stops' ,
                                value: orderBreakdownData.moreThan4DropOff
                              }
                            ]}
                            cx={255}
                            cy={150}
                            
                            innerRadius={75}
                            outerRadius={125}
                              fill="#8884d8"
                              paddingAngle={0}
                              dataKey="value"
                              margin={{ top: 5, right: 5, bottom: 115, left: 5 }}
                            >
                              {[1,2,3,4].map((e, index) => (
                                <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                              ))}
                              
                            </Pie>
                            <Tooltip/>
                            <Legend layout="horizontal" align="centre" verticalAlign="bottom" content={renderLegend} />
                           </PieChart> 
                          
                          }
                          {
            !orderBreakdownData && 
            <p>No bookings for the past 7 days</p>
        }
                          
                          </IonCol>
                        </IonRow>
                    </IonGrid>
                  }
                    { orderBreakdownData.total === 0 &&
                      <IonGrid>
                          <IonRow >
                          <IonCol size="12">
                            <h4><b>Order Type Breakdown</b></h4>
                          </IonCol>
                          <IonCol>
                            <p className="no-bookings">No data</p>
                          </IonCol>

                          </IonRow>
                      </IonGrid>
                    }

                </div>
              </IonCol>
              <IonCol size="6">
              <div className="dashboard-card-wrapper pie-chart">
                      <h4><b>Payment Methods</b></h4>
                      { paymentAnalyticsData.length !== 0 &&
                      <PieChart width={800} height={400}>
                        <Pie
                          data={paymentAnalyticsData}
                          cx={255}
                              cy={150}
                              
                              innerRadius={75}
                              outerRadius={125}
                          fill="#8884d8"
                          paddingAngle={0}
                          dataKey="amount"
                        >
                          {paymentAnalyticsData.map((e, index) => (
                            <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                          ))}
                          
                        </Pie>
                        <Tooltip/>
                        <Legend layout="horizontal" align="centre" verticalAlign="bottom" content={renderLegendForPaymentMethods} />
                      </PieChart>
                    }
                    {
                      paymentAnalyticsData.length === 0 && 
                      <p className="no-bookings">No data</p>
                    }
                </div>
              </IonCol>
              </IonRow>
            </IonGrid>
            
           
            
          </div> 
      </IonContent>
    </IonPage>
    </IonApp>
        </>
    )
}

export default CorePageComponent